import { makeStyles, MenuItem } from "@fluentui/react-components";
import { Link } from "react-router-dom";
import { dolphinTokens } from "../../../utils/Theme";

interface IMenuItemLinkProps {
    to: string;
    label: string;
}

const useStyles = makeStyles({
    root: {
        maxWidth: "none",
        minHeight: "unset",
        alignItems: "center",
        padding: "11px 14px",
        margin: "0 -14px 2px",
        borderRadius: "12px",
        backgroundColor: "transparent",
        color: dolphinTokens.colorDarkBlue,
        "--colorStrokeFocus2": dolphinTokens.colorLightBlue,
        ":hover": { backgroundColor: dolphinTokens.colorLightBlue20, color: dolphinTokens.colorLightBlue },
        "[data-fui-focus-visible]": { backgroundColor: dolphinTokens.colorLightBlue20, color: dolphinTokens.colorLightBlue },
        ":hover:active": { backgroundColor: dolphinTokens.colorLightBlue20, color: dolphinTokens.colorLightBlue },
    },
    link: {
        display: "block",
        width: "100%",
        fontSize: "16px",
        fontWeight: 500,
        textAlign: "left",
        textDecorationLine: "none",
        color: "inherit",
    }
});

const MenuItemLink = (props: IMenuItemLinkProps) => {
    const { to, label } = props;
    const styles = useStyles();

    return (
        <MenuItem className={styles.root}>
            <Link to={to} className={styles.link}>{label}</Link>
        </MenuItem>
    );
};

export default MenuItemLink;